module.exports = __webpack_public_path__ + "img/shield.23a91ef4.svg";